import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/star-icon.svg'
import _imports_1 from '../../assets/chameleon-magnifying-glass.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a9f1a6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  role: "main"
}
const _hoisted_2 = {
  key: 0,
  class: "complete-pathway-page"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  "data-test": "cpp-title",
  class: "col-md-12 complete-page-message text-center personal-pathway-message"
}, " Congratulations! You have completed: ", -1))
const _hoisted_4 = {
  key: 1,
  class: "col-md-12 outcome-title"
}
const _hoisted_5 = { class: "outcome-title-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "outcome-image-container" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  style: {"margin-bottom":"20px"},
  class: "outcome-title complete-pathway-details"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pathway: ", -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "outcome-image-container" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "complete-pathway-details" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "pathway-benefits" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "benefits-title" }, "Benefits", -1))
const _hoisted_19 = { class: "benefits-list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "bullet-point",
  class: "star-icon"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "complete-instructions" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-primary",
  href: "/home?view=MyDashboard",
  "data-test": "cpp-complete-btn"
}, " Complete ", -1))
const _hoisted_23 = {
  key: 1,
  class: "no-progress-container"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "chameleon with a magnifying glass",
    "data-test": "cpp-error-image"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "text-center no-progress-message",
  "data-test": "cpp-error-text"
}, " \"Oops! You need to complete every step before you can complete a pathway!\" ", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

import { computed, ref } from "vue";
import { useAxios } from "../../composables/api";
import LoadingPage from "../loading-page.vue";
import Confetti from "../../components/lottie-confetti.vue";
import { PersonalPathwayProgressApiModel } from "../../api-models";
import cms from "../../services/cms/cms";
import { CmsDocumentTypes } from "../../services/cms/cms-type-configuration";
import { CmsGoalData, CmsPersonalPathway } from "../../services/cms/cms-type-definitions";


export default /*#__PURE__*/_defineComponent({
  __name: 'complete-personal-pathway',
  setup(__props) {

const doc = ref<CmsPersonalPathway | null>(null);
const hasNoCurrentPathway = ref(false);
const showConfetti = ref(false);

const { data: currentPathway, promise: currentPathwayPromise } =
  useAxios<PersonalPathwayProgressApiModel>("/api/personalpathway/current");

currentPathwayPromise.then((data) => {
  if (!data.currentPathway?.cmsPersonalPathwayId) {
    hasNoCurrentPathway.value = true;
    return;
  }
  cms
    .getById(CmsDocumentTypes.CmsPersonalPathway, data.currentPathway?.cmsPersonalPathwayId)
    .then((cmsData) => {
      doc.value = cmsData;
    });
});

const pathwayIsCompleted = computed(() => !!currentPathway.value?.currentPathway?.isCompleted);
const isLoaded = computed(
  () => (!!currentPathway.value && !!doc.value) || hasNoCurrentPathway.value,
);
const outcome = computed<CmsGoalData | undefined>(
  () => doc.value?.data.goal_relationship.data as CmsGoalData,
);

function toggleConfetti(): void {
  if (!showConfetti.value) {
    showConfetti.value = true;
    setTimeout(() => {
      showConfetti.value = false;
    }, 2000);
  }
}

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (pathwayIsCompleted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (showConfetti.value)
                ? (_openBlock(), _createBlock(Confetti, {
                    key: 0,
                    ref: "confetti"
                  }, null, 512))
                : _createCommentVNode("", true),
              _hoisted_3,
              (!!outcome.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "outcome-title-header",
                        innerHTML: _unref(cms).asHtml(outcome.value.full_title)
                      }, null, 8, _hoisted_6),
                      _createElementVNode("p", {
                        class: "outcome-title-desc",
                        innerHTML: _unref(cms).asHtml(outcome.value.brief_description)
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: outcome.value.image.url,
                        alt: _unref(cms).asText(outcome.value.name),
                        class: "outcome-image"
                      }, null, 8, _hoisted_9)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(_unref(cms).asText(doc.value.data.title)), 1)
                  ]),
                  _createElementVNode("p", {
                    innerHTML: _unref(cms).asHtml(doc.value.data.short_description)
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("img", {
                    src: doc.value.data.title_image.url,
                    alt: _unref(cms).asText(outcome.value.name),
                    class: "outcome-image"
                  }, null, 8, _hoisted_14)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", {
                  innerHTML: _unref(cms).asHtml(doc.value.data.pathway_complete_content),
                  class: "pathway-complete-text"
                }, null, 8, _hoisted_16),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doc.value.data.benefits, (benefit, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `benefit` + index,
                        class: "benefit-item"
                      }, [
                        _hoisted_20,
                        _createElementVNode("p", null, _toDisplayString(_unref(cms).asText(benefit.benefit_description)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_21,
              _createElementVNode("div", { class: "button-container" }, [
                _hoisted_22,
                _createElementVNode("button", {
                  class: "btn btn-default-celebrate",
                  onClick: toggleConfetti,
                  type: "button"
                }, " Celebrate! ")
              ])
            ]))
          : (!pathwayIsCompleted.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
            : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})